/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_X15_Not_MemberInputs */

const en_auth_x15_not_member = /** @type {(inputs: Auth_X15_Not_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No team account uses that Google address. Sign in with your work email, or ask an admin to invite that address.`)
};

/** @type {(inputs: Auth_X15_Not_MemberInputs) => LocalizedString} */
const ar_auth_x15_not_member = en_auth_x15_not_member;

/** @type {(inputs: Auth_X15_Not_MemberInputs) => LocalizedString} */
const he_auth_x15_not_member = en_auth_x15_not_member;

/** @type {(inputs: Auth_X15_Not_MemberInputs) => LocalizedString} */
const ur_auth_x15_not_member = en_auth_x15_not_member;

/** @type {(inputs: Auth_X15_Not_MemberInputs) => LocalizedString} */
const es_auth_x15_not_member = en_auth_x15_not_member;

/** @type {(inputs: Auth_X15_Not_MemberInputs) => LocalizedString} */
const fr_auth_x15_not_member = en_auth_x15_not_member;

/** @type {(inputs: Auth_X15_Not_MemberInputs) => LocalizedString} */
const de_auth_x15_not_member = en_auth_x15_not_member;

/** @type {(inputs: Auth_X15_Not_MemberInputs) => LocalizedString} */
const pt_auth_x15_not_member = en_auth_x15_not_member;

/** @type {(inputs: Auth_X15_Not_MemberInputs) => LocalizedString} */
const hi_auth_x15_not_member = en_auth_x15_not_member;

/** @type {(inputs: Auth_X15_Not_MemberInputs) => LocalizedString} */
const bn_auth_x15_not_member = en_auth_x15_not_member;

/**
* | output |
* | --- |
* | "No team account uses that Google address. Sign in with your work email, or ask an admin to invite that address." |
*
* @param {Auth_X15_Not_MemberInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const auth_x15_not_member = /** @type {((inputs?: Auth_X15_Not_MemberInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_X15_Not_MemberInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_auth_x15_not_member(inputs)
	if (locale === "he") return he_auth_x15_not_member(inputs)
	if (locale === "ur") return ur_auth_x15_not_member(inputs)
	if (locale === "es") return es_auth_x15_not_member(inputs)
	if (locale === "fr") return fr_auth_x15_not_member(inputs)
	if (locale === "de") return de_auth_x15_not_member(inputs)
	if (locale === "pt") return pt_auth_x15_not_member(inputs)
	if (locale === "hi") return hi_auth_x15_not_member(inputs)
	if (locale === "bn") return bn_auth_x15_not_member(inputs)
	return /** @type {LocalizedString} */ ("No team account uses that Google address. Sign in with your work email, or ask an admin to invite that address.")
});